function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('./module/purchase'),
  configPurchaseService = _require.configPurchaseService;
var _require2 = require('./utils.js'),
  round = _require2.round;
var reportFeeBuster = function reportFeeBuster(cart, cash) {
  var purchaseService = configPurchaseService(cart);
  var driverTip = purchaseService.totals.driverTip();
  var serviceFee = purchaseService.totals.serviceFee();
  var useLowerItemPrices = purchaseService.totals.useLowerItemPrices(cash);
  var getBasePriceIncrease = function getBasePriceIncrease() {
    var basePriceIncrease = 0;
    purchaseService.purchases.forEach(function (p) {
      if (p.priceTaxFeeAdjustments) {
        p.priceTaxFeeAdjustments.forEach(function (a) {
          if (a.name === 'feebuster' || a.name === 'promo' && a.extra.feeBuster) {
            basePriceIncrease += a.price * (p.refund ? -1 : 1);
          }
        });
      }
    });
    return basePriceIncrease;
  };
  var getExtraTax = function getExtraTax() {
    return round(purchaseService.totals.tax() - purchaseService.totals.tax('cash'));
  };
  var getFeeBusterNetAmount = function getFeeBusterNetAmount() {
    return round(purchaseService.totals.totalDues() - driverTip - serviceFee - purchaseService.totals.totalDues('cash'));
  };
  var feeBusterNetAmount = getFeeBusterNetAmount();
  var result = _objectSpread({
    cashDiscountOn: purchaseService.feeBusterConfig.enabled,
    feebusterfraction: purchaseService.feeBusterConfig.fraction,
    priceincreaseenabled: purchaseService.priceIncrease
  }, useLowerItemPrices ? {
    cashsaving: feeBusterNetAmount
  } // cashsaving is also "feebuster" in mp/papi
  : {
    basepriceincrease: getBasePriceIncrease(),
    // "feebuster" in mp/papi
    extratax: getExtraTax(),
    // "feebuster_tax" in mp/papi
    netcharge: feeBusterNetAmount // netcharge is "payinfobycardtype"(mp) and "gpi"(papi)
  });
  purchaseService.clearRegister();
  return result;
};
module.exports = reportFeeBuster;